<template>
  <div>
    <b-card no-body>
      <b-row>
        <b-col cols="12">
          <b-row class="pb-1 mt-50">
            <b-col class="text-left" cols="5">
              <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="New()">
                <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
                Thêm mới
              </b-button>
              <b-button class="btn-sm" variant="primary" @click="Deletes()">
                <feather-icon class="align-text-top" icon="DeleteIcon" size="16"/>
                Xóa
              </b-button>
            </b-col>
            <b-col class="text-right" cols="6">
              <b-button class="btn-sm mr-50" variant="primary" @click="$refs.fileInput.click()">
                <feather-icon class="align-text-top" icon="ImportIcon" size="16"/>
                Nhập file
              </b-button>
              <input id="fileInput" ref="fileInput" style="display:none;" type="file" @change="importFile">
              <b-button class="btn-sm mr-50" variant="primary" @click="ExportTemp()">
                <feather-icon class="align-text-top" icon="ExortIcon" size="16"/>
                Tải file mẫu
              </b-button>
              <b-button class="btn-sm " variant="primary" @click="ExportFile()">
                <feather-icon class="align-text-top" icon="ExortIcon" size="16"/>
                Xuất file
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [20, 50, 100], dropdownAllowAll: false }"
                              :rows="items" :select-options="{ enabled: true }"
                              :totalRows="totalRecords"
                              mode="remote" @on-page-change="onPageChange"
                              @on-sort-change="onSortChange"
                              @on-column-filter="onColumnFilter"
                              @on-per-page-change="onPerPageChange" @on-selected-rows-change="selectionChanged">
                <template slot="table-row" slot-scope="props">
                  <!-- Column: Action -->
                  <span v-if="props.column.field === 'action'">
                    <span>
                      <b-button class="btn-icon" size="sm" variant="primary" @click="Edit(props.row, props.row.id)">
                        <feather-icon icon="Edit2Icon"/>
                      </b-button>
                      <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                                @click="DeleteItem(props.row, props.row.id)">
                        <feather-icon icon="TrashIcon"/>
                      </b-button>
                    </span>
                  </span>
                </template>
              </vue-good-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-modal id="modal-edit" :title="getTitle()" size="xl" @ok="handleOk">
      <b-row>
        <b-col cols="3">
          <b-form-group label="Danh mục">
            <Select2 v-model="currentItem.category_id" :options="categoryList"
                     v-bind:class="{ 'readonly': editMode, '': !editMode }" v-on:change="catOnChange"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Chủ đề">
            <Select2 v-model="currentItem.topic_id" :options="topicList"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label>Trạng thái<span class='text-danger'>*</span></label>
            <Select2 v-model="currentItem.status" :options="statusList" :state="validateState('status')" minlength="3"
                     required/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label>Ngày hiệu lực<span class='text-danger'>*</span></label>
            <b-form-input v-model="currentItem.effect_date" :state="validateState('effect_date')" placeholder="Ngày hiệu lực" required
                          type="date"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <b-form-group label="Phòng ban chủ trì">
            <Select2 v-model="currentItem.department_presiding_id" :options="departmentList"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Phòng ban tham gia">
            <Select2 v-model="currentItem.department_join_id" :options="departmentList"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label>Người soạn thảo</label>
            <b-form-input v-model="currentItem.creator_name" placeholder="Người soạn thảo" type="text"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label>Người phê duyệt</label>
            <b-form-input v-model="currentItem.approver" placeholder="Người phê duyệt" type="text"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <b-form-group>
            <label>Tên gói cước<span class='text-danger'>*</span></label>
            <b-form-input v-model="currentItem.name" :state="validateState('name')" placeholder="Tên gói cước" required
                          type="text"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label>Cước phí(vnđ)</label>
            <b-form-input v-model="currentItem.postage" :state="validateState('postage')" placeholder="Cước phí"
                          type="number"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label>Chu kỳ (ngày)</label>
            <!-- <b-input-group> -->
            <b-form-input v-model="currentItem.duration" :state="validateState('duration')" placeholder="Chu kỳ"
                          type="number"/>
            <!-- &nbsp;&nbsp; ngày </b-input-group> -->
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label>Gói nền</label>
            <b-form-input v-model="currentItem.package_daemon" :state="validateState('package_daemon')" placeholder="Gói nền"
                          type="text"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group>
            <label>Cách đăng ký</label>
            <b-form-input v-model="currentItem.how_to_register" :state="validateState('how_to_register')" placeholder="Cách đăng ký"
                          type="text"/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <label>Gói bổ sung</label>
            <b-form-input v-model="currentItem.pack_extra" :state="validateState('pack_extra')" placeholder="Gói bổ sung"
                          type="text"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <!-- <b-form-textarea id="textarea-auto-height" placeholder="Ưu đãi gói cước" rows="5"
            v-model="currentItem.contents" max-rows="5" /> -->
          <!-- <quill-editor class="editor-form" v-model="currentItem.contents" ref="quillEditor"
            placeholder="Ưu đãi gói cước" /> -->
          <ckeditor v-model="currentItem.contents" :config="editorConfig" :editor-url="editorUrl"
                    class="editor-form" placeholder="Ưu đãi gói cước"></ckeditor>

        </b-col>
      </b-row>
      <b-col class="mt-50 text-left" cols="12">
        <b-form-group>
          <div v-if="currentItem && currentItem.file_path">
            <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger" @click="removeFile()">
              <feather-icon icon="TrashIcon"/>
            </b-button>
            <lable>{{currentItem.file_path}}</lable>
          </div>
          <div class="clearfix mb-0 mt-50"></div>
          <b-form-file v-model="currentItem.file" accept="application/pdf,application/vnd.ms-excel,application/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document" class="mrt-10" plain
                       v-on:input="uploadFile">
          </b-form-file>
        </b-form-group>
      </b-col>
    </b-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import {getuserName, TypeCategories} from '@/@core/utils/utils';

import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend,
    BFormFile
  },
  methods: {
    getTitle() {
      if (this.editMode) {
        return "Cập nhật gói cước ";
      } else {
        return "Thêm mới gói cước ";
      }
    },
    validateState(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItem[pro]) return false;
      else return true;
      return null;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    loadItems() {
      try {
        this.loading(true);
        let data = {
          ...this.serverParams,
          columnFilters: {
            ...(this.serverParams.columnFilters ? this.serverParams.columnFilters : [])
          }
        }
        if (data.columnFilters.created_date != undefined) {
          delete data.columnFilters['created_date_']
        }
        useJwt
            .post("portal/packofdatas", data)
            .then((response) => {
              this.items = response.data.result;
              this.totalRecords = response.data.totalRecords;
              this.isLoading = false;
              this.loading(false);
            });
      } catch (ex) {
        this.loading(false);
      }
    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới gói cước ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật gói cước";
      this.$bvModal.show("modal-edit");
    },

    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `portal/packofdata/${item.id}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu gói cước",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          this.loading(true);
          let res = await useJwt.delete(url);
          if (res.data.code == 200) {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá gói cước thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
          this.loading(false);
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá gói cước ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    selectionChanged(params) {
      this.rowSelection = params.selectedRows;
    },
    async Deletes() {
      if (this.rowSelection.length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn dữ liệu cần xóa. Xin vui lòng kiểm tra lại!",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu Gói cước",
          {title: "Please Confirm", size: "sm"}
      );

      if (resModal) {
        const listId = [];
        for (var i = 0; i < this.rowSelection.length; i++) {
          listId.push(this.rowSelection[i].id);
        }
        const deleteParams = {
          ids: listId.join(',')
        };
        try {
          this.loading(true);
          const res = await useJwt.post("portal/deletePackOfDatas", deleteParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.loadItems();
            return this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xóa Gói cước thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xóa Gói cước ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    async loadCategories() {
      useJwt.get("portal/getAllCategories").then((response) => {
        var result = response.data;
        if (result.code == 200) {
          this.categoryList = [];
          this.topicList = [];
          this.topicAll = [];
          result.result.forEach(item => {
            if (item.cat_type == 0 && item.cat_type_new == TypeCategories.PACKDATA) {
              this.categoryList.push({'id': item.id, 'text': item.name});
            } else if (item.cat_type_new == TypeCategories.PACKDATA) {
              this.topicAll.push({'id': item.id, 'text': item.name, 'parent_id': item.parent_id});
              this.topicList.push({'id': item.id, 'text': item.name, 'parent_id': item.parent_id});
            }
          });
        }
      });
    },
    async loadDepartment() {
      useJwt
          .get("portal/departments")
          .then((response) => {
            this.departmentList = [];
            response.data.result.forEach(item => {
              this.departmentList.push({'id': item.id, 'text': item.name});
            });
            this.isLoading = false;
          });
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const userName = getuserName();
      this.isSubmit = true;
      const bIsValid = await this.isValidDa(this.currentItem);
      if (!bIsValid) {
        return;
      }
      if (this.editMode) {
        const url = `portal/packofdata/${this.currentItem.id}`;
        const updateParams = {
          id: this.currentItem.id,
          category_id: this.currentItem.category_id,
          topic_id: this.currentItem.topic_id,
          name: this.currentItem.name,
          applicable_object: this.currentItem.applicable_object,
          status: this.currentItem.status,
          effect_date: this.currentItem.effect_date,
          department_presiding_id: this.currentItem.department_presiding_id,
          department_join_id: this.currentItem.department_join_id,
          creator_name: this.currentItem.creator_name,
          approver: this.currentItem.approver,
          contents: this.currentItem.contents,
          created_at: userName,
          updated_at: userName,
          postage: this.currentItem.postage,
          duration: this.currentItem.duration,
          package_daemon: this.currentItem.package_daemon,
          how_to_register: this.currentItem.how_to_register,
          pack_extra: this.currentItem.pack_extra,
          file_path: this.currentItem.file_path
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.isSubmit = false;
            this.$bvModal.hide("modal-edit");
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi thêm mới gói cước ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        this.loading(true);
        const createParams = {
          id: 0,
          category_id: this.currentItem.category_id,
          topic_id: this.currentItem.topic_id,
          name: this.currentItem.name,
          applicable_object: this.currentItem.applicable_object,
          status: this.currentItem.status,
          effect_date: this.currentItem.effect_date,
          department_presiding_id: this.currentItem.department_presiding_id,
          department_join_id: this.currentItem.department_join_id,
          creator_name: this.currentItem.creator_name,
          approver: this.currentItem.approver,
          contents: this.currentItem.contents,
          created_at: userName,
          updated_at: userName,
          postage: this.currentItem.postage,
          duration: this.currentItem.duration,
          package_daemon: this.currentItem.package_daemon,
          how_to_register: this.currentItem.how_to_register,
          pack_extra: this.currentItem.pack_extra,
          file_path: this.currentItem.file_path
        };
        const res = await useJwt.post("portal/packofdata", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.loadItems();
          this.$bvModal.hide("modal-edit");
          this.isSubmit = false;
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới gói cước thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });

        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới gói cước ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async isValidDa(item) {
      if (!item.name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tên không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      if (item.status == null || item.status === '' || item.status == undefined) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Trạng thái không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    },

    async quickSearch() {
      this.loadItems();
    },
    catOnChange(e) {
      this.topicList = this.topicAll.filter(function (item) {
        return item.parent_id == e
      });
    },
    async uploadFile() {
      try {
        if (!this.currentItem.file) {
          return;
        }
        this.loading(true);
        var formData = new FormData();
        formData.append("file", this.currentItem.file);
        const res = await useJwt.post(`portal/upload`, formData);
        this.loading(false);
        if (res.data.code == 200) {
          this.currentItem.file_path = res.data.result;
          this.currentItem.file = '';
        }
      } catch {
        this.loading(false);
      }

    },
    removeFile() {
      this.currentItem.file_path = '';
      this.currentItem.file = '';
    },
    async ExportTemp() {
      try {
        this.loading(true);
        await useJwt.getFile("portal/downloadpackfiletemp", 'Goi_cuoc_temp.xlsx');
        this.loading(false);
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    },
    async ExportFile() {
      try {
        this.loading(true);
        await useJwt.getFile("portal/downloadPackexcel", 'Goi_cuoc.xlsx');
        this.loading(false);
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    },
    async importFile(e) {
      try {
        const fileImport = this.$refs.fileInput.files[0];
        if (fileImport != null) {
          var formData = new FormData();
          formData.append("file", fileImport);
          this.loading(true);
          const res = await useJwt.post("portal/importPackExcel", formData);
          this.loading(false);
          if (res.data.code != 200) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger"
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Nhập file thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
            this.loadItems();
          }
        }
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Nhập file thất bại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    }
  },

  mounted() {
    this.isSubmit = false;
    this.loadItems();
    this.loadCategories();
    this.loadDepartment();
  },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      items: [],
      statusList: [
        {id: 1, text: "Hiệu lực"},
        {id: 0, text: "Hết hiệu lực"}
      ],
      categoryList: [],
      topicList: [],
      topicAll: [],
      departmentList: [],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      currentItem: {},
      options: {
        fields: [
          {field: "action", label: "Cài đặt", width: "120px"},
          {
            field: "topicName",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Chủ đề",
            required: true
          },
          {
            field: "name",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Tên gói cước",
            required: true
          },
          {
            field: "contents",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Ưu đãi gói",
            required: true
          },
          {
            field: "postage",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Cước phí (vnđ)",
            tdClass: 'text-right',
            required: true
          },
          {
            field: "duration",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Chu kỳ (ngày)"
          },
          {
            field: "package_daemon",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Gói nền"
          },
          {
            field: "how_to_register",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Cách đăng ký"
          },
          {
            field: "pack_extra",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Gói bổ sung",
            required: true
          },
          {
            field: "statusName",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Trạng thái"
          },
          {
            field: "effect_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày hiệu lực",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'dd/MM/yyyy',
            disabled: true
          },
          {
            field: "department_presiding_name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Phòng ban chủ trì",
            required: true
          },
          {
            field: "department_join_name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Phòng ban tham gia",
            required: true
          },
          {
            field: "creator_name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Người soạn thảo",
            required: true
          },
          {
            field: "approver",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Người phê duyệt",
            required: true
          }
        ]
      },
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "created_date", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 20,
        "lang": 1
      },
      editorUrl: 'https://cdn.ckeditor.com/4.20.0/full-all/ckeditor.js',
      editorConfig: {
        extraPlugins: 'tableresize',
        toolbarGroups: [
          {name: 'document', groups: ['mode', 'document', 'doctools']},
          {name: 'clipboard', groups: ['clipboard', 'undo']},
          {name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing']},
          {name: 'forms', groups: ['forms']},
          {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
          {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']},
          {name: 'links', groups: ['links']},
          {name: 'insert', groups: ['insert']},
          {name: 'styles', groups: ['styles']},
          {name: 'colors', groups: ['colors']},
          {name: 'tools', groups: ['tools']},
          {name: 'others', groups: ['others']},
          {name: 'about', groups: ['about']}
        ]
      }
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
.ql-editor {
  min-height: 200px;
}

.vgt-table td,
.vgt-table th {
  max-width: 300px;
}
</style>
